import { render, staticRenderFns } from "./AgentIntroSection.vue?vue&type=template&id=6020d50b&scoped=true&"
import script from "./AgentIntroSection.vue?vue&type=script&lang=js&"
export * from "./AgentIntroSection.vue?vue&type=script&lang=js&"
import style0 from "./AgentIntroSection.vue?vue&type=style&index=0&id=6020d50b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020d50b",
  null
  
)

export default component.exports